import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useForgotPassword = () => {
	return useMutation({
		mutationFn: async (email: string) => {
			await api.post('/user/recover', { email }).catch((error) => {
				throw toApiError(error, 'Erro ao solicitar recuperação de senha');
			});
		},
		onError: (error) => {
			console.error(
				'Erro ao solicitar recuperação de senha:',
				getApiErrorMessage(error, 'Erro ao solicitar recuperação de senha')
			);
		},
	});
};
